export const SHEET_NAME = {
  vi: `Chỉ hỗ trợ file .xlsx`,
  en: `Only .xlsx files are supported`
}
